module.exports = __webpack_public_path__ + "img/bg.a1225aaa.png";